export default __webpack_public_path__ + "wp-content/uploads/react/user-dashboard/media/MaterialIcons-Regular.5e7382c6.ttf";